export default "__VITE_ASSET__0cbcc206__$_?component__"